import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBPWykaxTSlGMo8qChWNxcz9sIAFNzz2fQ",
    authDomain: "vine-matched.firebaseapp.com",
    projectId: "vine-matched",
    storageBucket: "vine-matched.firebasestorage.app",
    messagingSenderId: "741307205156",
    appId: "1:741307205156:web:1dbbfba20ae2dededa3ab1",
    measurementId: "G-0PSD70ZZD3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, auth, db, storage };